import Model from "../../Model.js";

/**
 *
 * `AbstractSpecificationVisitor` is an abstract class
 * exposing the public API of the concrete visitors
 * in order to visit the specifications.
 *
 * @abstract
 */
export default class AbstractSpecificationVisitor extends Model {
	visit(aSpecification) {
		return aSpecification.accept(this);
	}

	visitAll(aCollection) {
		return aCollection.map(function (each) {
			return this.visit(each);
		});
	}

	visitCompositeSpecification(_aSpecification) {
		this._subclassResponsibility();
	}

	visitOrSpecification(aSpecification) {
		return this.visitCompositeSpecification(aSpecification);
	}

	visitAndSpecification(aSpecification) {
		return this.visitCompositeSpecification(aSpecification);
	}

	visitNotSpecification(_aSpecification) {
		this._subclassResponsibility();
	}
}
